<template>
	<div id="new-password" class="container">
		<div class="container__form" :class="showSuccess ? 'small' : ''">
			<div class="container__form-title">
				<div class="container__form-body">
					<PasswordForm :isWeb="isWeb" @handleSuccess="handleSuccess" v-if="!showSuccess" />
					<SuccessSended @handleSuccess="handleSuccess" :newPassword="true" v-else />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import PasswordForm from '@/components/modules/Login/PasswordForm/PasswordForm.vue';
import SuccessSended from '@/components/modules/Login/SuccessSended/SuccessSended.vue';

export default {
	name: 'NewPassword',
	components: { PasswordForm, SuccessSended },
	data: () => ({
		windowWidth: window.innerWidth,
		showSuccess: false,
	}),
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', this.onResize);
		});
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.onResize);
	},
	methods: {
		onResize() {
			this.windowWidth = window.innerWidth;
		},
		handleSuccess() {
			this.showSuccess = !this.showSuccess;
		},
	},
	computed: {
		isWeb() {
			return this.windowWidth > 992;
		},
	},
};
</script>

<style lang="scss">
@import 'NewPassword.scss';
</style>
